import * as React from "react";
const SvgFiRrFaceSadSweat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-sad-sweat_svg__a)">
      <path
        fill="#062147"
        d="M12 16c1.965 0 3.531 1.149 3.597 1.198a.998.998 0 1 1-1.194 1.603c-.007-.005-1.114-.802-2.403-.802s-2.396.797-2.407.805a.999.999 0 0 1-1.19-1.607c.066-.049 1.632-1.198 3.597-1.198zm0-16A11.96 11.96 0 0 0 1.309 6.545a1.001 1.001 0 0 0 1.782.91A9.97 9.97 0 0 1 12.001 2c5.514 0 10 4.486 10 10s-4.486 10-10 10a9.96 9.96 0 0 1-6.863-2.728 1 1 0 1 0-1.373 1.455 11.95 11.95 0 0 0 8.236 3.272c6.617 0 12-5.383 12-12S18.617 0 12 0m5.726 8.962q.138.038.275.038a1 1 0 0 0 .274-1.962c-.965-.275-1.977-.941-2.46-1.619a1 1 0 1 0-1.628 1.163c.746 1.045 2.135 1.979 3.54 2.381zm-9.54-3.543c-.484.678-1.496 1.344-2.46 1.619a1 1 0 0 0 .549 1.924c1.404-.401 2.793-1.336 3.54-2.381a1 1 0 0 0-1.628-1.163zM8.5 11a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 11m7 3a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 15.5 14M5 14.5c0-1.403-1.184-3.372-1.922-4.235a.754.754 0 0 0-1.151.004C1.189 11.143 0 13.13 0 14.5a2.5 2.5 0 1 0 5 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-sad-sweat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSadSweat;
